import React from "react";
import Radiobutton from "./Radiobutton";
import Input from "./Input";

const BookDetect = ({booking, setBooking, setInput, errors, title, target, address, placeName}) => {
    return (
        <div className='bookDetect'>
            <div className='bookDetect-title'>{title ? title : ''}</div>
            <div className='bookDetect-items'>
                <div className='bookDetect-item'>
                    <Radiobutton
                        currentCheck={booking}
                        setBooking={setBooking}
                    />
                    <span>{target ? target : ''}</span>
                </div>
            </div>
            {booking &&
                <div className='bookDetect-place'>
                    <Input 
                        name='placeName' 
                        onChange = {setInput('placeName')} 
                        value = {placeName}
                        errors = {errors}
                        label={'Название заведения'}
                    />
                    <Input 
                        name='place' 
                        onChange = {setInput('place')}  
                        value = {address}
                        errors = {errors}
                        label={'Адрес'}
                    />
                </div>
            }
        </div>
    )
}

export default BookDetect;


// WEBPACK FOOTER //
// ./src/components/BookDetect.jsx